<template>
  <nav-bar title="充装及检查人员首页" />
  <RoleName role="充装及检查人员" />
  <Content :bottom="0" :top="98">
    <div class="title">充装</div>
    <div class="btn">
      <van-button type="primary" v-if="isSuperFill === '1'" @click="onSuperCheck" block
      >扫码充装</van-button
      >
    </div>
    <div class="loading">
      <van-loading v-if="inventoryLoading.value" />
    </div>
    <ul v-if="summaryList.length" class="list">
      <li
        class="list-item"
        v-for="item in summaryList"
        :key="item.departmentId"
      >
        <div class="col">
          <span class="list-item__name">{{ item.departmentName }}</span>
          <span class="list-item__amount">{{ item.mediumName }}:{{ item.amount }}瓶</span>
          <van-button
            type="primary"
            size="mini"
            v-if="item.appStatus === '1'"
            :to="`/fillCheck/${item.departmentId}/${item.applyId}/${item.appStatus}`"
            >检查</van-button
          >
          <van-button
            type="primary"
            size="mini"
            v-if="item.appStatus === '2'"
            @click="onFill(item)"
            >充装</van-button
          >
        </div>
        <div class="col">
          <span class="list-item__name">{{ item.applyTime }}</span>
          <span class="list-item__amount">上次操作人：{{ item.empName }}</span></div>
      </li>
    </ul>
    <Empty
      v-if="!summaryList.length && !inventoryLoading.value"
      description="暂无记录"
    />
    <div class="title">付货</div>
    <div class="loading">
      <van-loading v-if="inventoryLoading.value" />
    </div>
    <ul v-if="inventoryList.length" class="list">
      <li
        class="list-item"
        v-for="item in inventoryList"
        :key="item.departmentId"
      >
        <div class="col">
          <span class="list-item__name">{{ item.departmentName }}</span>
          <span class="list-item__amount">{{ item.mediumName }}:{{ item.amount }}瓶</span>
          <van-button
            type="primary"
            size="mini"
            v-if="item.appStatus === '3'"
            @click="onCheck(item)"
            >检查</van-button
          >
          <van-button
            type="primary"
            size="mini"
            v-if="item.appStatus === '4'"
            :to="`/payGoodsDetail/${item.departmentId}/${item.applyId}/${item.appStatus}/${item.empId}`"
            >付货</van-button
          >
        </div>
        <div class="col">
          <span class="list-item__name">{{ item.applyTime }}</span>
          <span class="list-item__amount">上次操作人：{{ item.empName }}</span></div>
      </li>
    </ul>
    <Empty
      v-if="!inventoryList.length && !inventoryLoading.value"
      description="暂无记录"
    />
  </Content>
</template>
<script>
import { ref, computed } from 'vue'
import { cylinderSummaryList } from '@/api/cylinderManageUserHome'
import { useGetDataLoading } from '@/hooks/useGetData'
import { getDetail } from '@/api/modifyCompany'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { Toast } from 'vant'
export default {
  name: 'FillingUserHome', // 充装人员首页
  setup() {
    const router = useRouter()
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const isSuperFill = ref(0)
    const getInfo = () => {
      getDetail(companyId.value).then(({ data }) => {
        isSuperFill.value = data.isSpFill
      })
    }
    getInfo()
    const empId = computed(() => store.state.roleInfo.empId)
    // 获取出库列表
    const inventoryList = ref([])
    const inventoryLoading = ref(false)
    const inventory = useGetDataLoading(cylinderSummaryList, (data) => {
      inventoryList.value = data
    })
    inventoryLoading.value = inventory.loading

    // 获取入库列表
    const summaryList = ref([])
    const summaryLoading = ref(false)
    const summary = useGetDataLoading(cylinderSummaryList, (data) => {
      summaryList.value = data
      inventory.getData({
        companyId: companyId.value,
        summaryType: '1'
      })
    })
    summaryLoading.value = summary.loading
    summary.getData({
      companyId: companyId.value,
      summaryType: '0'
    })
    const onFill = (item) => {
      if (item.empId === empId.value) {
        Toast('冲装前检查人员和冲装人员不能为同一个人')
      } else {
        router.push(
          `/fillingDetail/${item.departmentId}/${item.applyId}/${item.appStatus}/${item.empId}`
        )
      }
    }
    const onCheck = (item) => {
      if (item.empId === empId.value) {
        Toast('付货前检查人员和冲装人员不能为同一个人')
      } else {
        router.push(
          `/PayGoodsCheck/${item.departmentId}/${item.applyId}/${item.appStatus}/${item.empId}`
        )
      }
    }
    const onSuperCheck = (item) => {
      router.push('/fillSuperCheck')
    }
    return {
      summaryList,
      summaryLoading,
      inventoryList,
      inventoryLoading,
      onFill,
      onCheck,
      onSuperCheck,
      isSuperFill
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn {
    margin:16px;
  }
.title {
  display: flex;
  align-items: center;
  position: relative;
  margin: 0 16px;
  font-size: 14px;
  height: 40px;
  text-indent: 10px;
  font-weight: 600;
  &::after {
    position: absolute;
    content: '';
    width: 3px;
    background: #666;
    height: 12px;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
  }
}
.list {
  padding: 0 16px;
  font-size: 14px;
  color: #666;
  .list-item {
    display: flex;
    flex-direction: column;
    padding: 5px 14px;
    background-color: #fff;
    box-shadow: rgba(87, 107, 146, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-top: 16px;
    .col {
      padding: 3px 0;
    }
    .col:first-child {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &__amount {
      margin: 0 16px;
      font-weight: 600;
    }
  }
}
.loading {
  text-align: center;
}
</style>
